var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-input"},[_c('label',{staticClass:"base-input__label"},[_c('legend',{staticClass:"base-input__legend",class:{
    'base-input__legend_decrease-legend': _vm.focused | _vm.isNotEmpty | _vm.isInputNotCorrect
  }},[_vm._v(" "+_vm._s(_vm.legend)+" ")]),_c('input',{ref:"self",staticClass:"base-input__input",class:{
             'base-input__input_loupe_icon': _vm.isSearchInput,
             'base-input__input_error': _vm.isInputNotCorrect,
           },attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":_vm.onInput}})]),(_vm.isInputNotCorrect)?_c('p',{staticClass:"base-input__error-message"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }